import React from 'react'
import {Box, Grid, Skeleton} from '@mui/material';
import {styled} from '@mui/material/styles';

const MainContainer = styled(Grid)(() => ({
  paddingTop: '2.86rem',
  paddingRight: '7.79vw',
  paddingLeft: '7.79vw',
}));

const RowGap5 = styled(Grid)(() => ({
  rowGap: '0.36rem',
}));

const WrapContent = styled(Box)(() => ({
  marginTop: '0.5em',
  marginBottom: '2em',
}));

const MainContent = styled(Grid)(() => ({
  marginTop: '2.5em',
}));

const MarginBottom = styled(Skeleton)(() => ({
  marginBottom: '2em',
  marginTop: '2em',
}));

const PolicyDocumentSkeleton = ({type}) => {

  return (
    <MainContainer container direction='column'>
      <WrapContent component='header'>
        <Skeleton variant='text' width={250}/>
        <RowGap5 container direction='column'>
          <Skeleton variant='text' width={300}/>
          <Skeleton variant='text' width={200}/>
        </RowGap5>
        <MarginBottom variant='text' width={250}/>
        {
          type === 'terms' && <Grid container alignItems='center' justifyContent='center' direction='column'>
            <Skeleton variant='text' width={'50%'} height={30}/>
          </Grid>
        }
        {
          [...Array(20).keys()].map((_, index) => (
            <MainContent container key={index} direction='column'>
              <Skeleton variant='text' width={100}/>
              <Skeleton variant='text' height={50}/>
            </MainContent>
          ))
        }
      </WrapContent>
    </MainContainer>
  )
}

export default PolicyDocumentSkeleton
